/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupsDto as DigiworkMaitreDPosDtoGroupGroupsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/groups-dto';

export interface GetGroups$Params {
  venueId?: string;
  isRemoved?: boolean;
  searchTerm?: string;
}

export function getGroups(http: HttpClient, rootUrl: string, params?: GetGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>> {
  const rb = new RequestBuilder(rootUrl, getGroups.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
    rb.query('isRemoved', params.isRemoved, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>;
    })
  );
}

getGroups.PATH = '/api/groups';
